import { Component, OnInit} from '@angular/core';


@Component({
    selector: 'contact-info',
    templateUrl: './contact-info.component.html'
})
export class ContactComponent implements OnInit {
  
  ngOnInit(){
  }
}
